<section class="user-journey-wrap">
  <div class="user-journey-inner">
    <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
      <div>
        <p class="text-uppercase text-primary text-xxs fw-bold mb-1">Getting started</p>
        <h5 class="fw-bold text-dark mb-1"> {{ title }}</h5>
        <p class="text-muted text-xxs mb-0">{{ subtitle }}</p>
      </div>
      <i class="bi bi-stars text-primary fs-4"></i>
    </div>

    <div class="row g-2">
      <div
        v-for="card in journey_cards"
        :key="card.title"
        class="col-12 col-md-6 col-xl-4"
      >
        <a
          v-if="card.href"
          :href="card.href"
          class="user-journey-feature d-flex align-items-start gap-3 rounded-3 border p-3 text-decoration-none h-100"
        >
          <span class="user-journey-icon rounded-circle d-inline-flex align-items-center justify-content-center">
            <i class="bi" :class="card.icon"></i>
          </span>
          <span class="min-w-0">
            <span class="d-block fw-bold text-dark text-xxs mb-1">{{ card.title }}</span>
            <span class="d-block text-muted text-xxs lh-sm mb-2">{{ card.description }}</span>
            <span class="text-primary text-xxs fw-bold">{{ card.action }}</span>
          </span>
        </a>

        <button
          v-else
          type="button"
          class="user-journey-feature d-flex align-items-start gap-3 rounded-3 border p-3 text-start bg-transparent w-100 h-100"
          :data-bs-toggle="card.modal ? 'modal' : null"
          :data-bs-target="card.modal || null"
          @click="handle_card_click(card)"
        >
          <span class="user-journey-icon rounded-circle d-inline-flex align-items-center justify-content-center">
            <i class="bi" :class="card.icon"></i>
          </span>
          <span class="min-w-0">
            <span class="d-block fw-bold text-dark text-xxs mb-1">{{ card.title }}</span>
            <span class="d-block text-muted text-xxs lh-sm mb-2">{{ card.description }}</span>
            <span class="text-primary text-xxs fw-bold">{{ card.action }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</section>
